module.exports = __webpack_public_path__ + "static/media/square.e779d12a.svg";